module.exports = __webpack_public_path__ + "img/newmodel_supervised.7e2fb3e0.png";